module.exports = __webpack_public_path__ + "static/media/photo113.06e693ab.jpg";